<template>
  <div class="overflow-x-auto scrollbar-hidden member-datatable" data-test="member-datatable">
      <Datatable :api-params="paramsComputed" :api-url="'member'" :method-request="'GET'" :init-sorter="[{field: 'UPDATE_DATETIME', dir: 'desc'}]" :data-array="dataArray" :data-array-table="dataArrayTable" :key="key" :downloadFile="downloadFile" @getDataComplete="exportFile" @rowClicked="handleRowClick" question-group="member" stacked-mobile />
  </div>
</template>

<script setup>
import Datatable from "@/components/datatable/index.vue"
import { reactive,ref, watch, computed } from "vue"
import { utils, writeFile } from "xlsx"
import Swal from 'sweetalert2'
import { useRouter } from "vue-router";
import { getPermissionAccessMenu } from "@/utils/getPermission"
import { hashText } from "@/utils/encrypt.js"
import { useStore } from "vuex";
// import axios from "axios"
const props = defineProps({
    filter:{
        type: Object
    },
    downloadCsv:{
        type: String
    },
    downloadExcel: {
        type: String
    }
})
const emits = defineEmits(["downloadCsvComplete", "downloadExcelComplete"])
const dataArray = ref()
const params = ref({start: 1,draw: 1,length: 10})
const key = ref(1)
const downloadFile = ref(false)
const downloadFormat = ref(null)
const currentFileType = ref("")
const router = useRouter()
const store = useStore()
const onlineComputed = computed(()=> store.getters["network/isOnline"])
watch(()=>props.filter, ()=>{
    key.value++
})
const paramsComputed = computed(() => ({...params.value, ...props.filter}))
var customAgeRange = (value, data, type, params, component) => {
    return {
        "baby": data.member_surveys?.age_range ? data.member_surveys.age_range.some(x=> x === "เด็กแรกเกิด/ปฐมวัย (อายุ 0-5 ปี)") : false,
        "kid": data.member_surveys?.age_range ? data.member_surveys.age_range.some(x=> x === "วัยเรียน (อายุ 5-14 ปี)") : false,
        "teenager": data.member_surveys?.age_range ? data.member_surveys.age_range.some(x=> x === "วัยรุ่น/นักศึกษา (อายุ 15-21 ปี)") : false,
        "adult": data.member_surveys?.age_range ? data.member_surveys.age_range.some(x=> x === "วัยผู้ใหญ่/วัยแรงงาน (อายุ 18-59 ปี)") : false,
        "elder": data.member_surveys?.age_range ? data.member_surveys.age_range.some(x=> x === "วัยผู้สูงอายุ (60 ปีขึ้นไป)") : false
    }
}
const dataArrayTable = reactive([
    {title:"สถานะตรวจสอบ", field:"is_verified", hozAlign:"center", resizable:true, width: 155, formatter:"textarea", formatter:function(cell, formatterParams){
        return cell.getValue() ? 
        `<span class="flex items-center md:bg-theme-47 text-theme-46 md:text-xs font-medium px-2 py-0.5 rounded-full">
            <span class="h-1.5 w-1.5 bg-theme-46 rounded-full mr-1"></span>
            ผ่าน
        </span>`
        : 
        `<span class="flex items-center md:bg-theme-49 text-theme-48 md:text-xs font-medium px-2 py-0.5 rounded-full">
            <span class="h-1.5 w-1.5 bg-theme-48 rounded-full mr-1"></span>
            ไม่ผ่าน
        </span>`
    }},
    {title:"ชื่อ-นามสกุล", field:"full_name", minWidth: 200, resizable:true, formatter:"textarea"},
    {title:"เลขบัตรประจำตัวประชาชน", field:"NID", hozAlign:"left",minWidth: 200, width: 230, resizable:true, formatter:function(cell, formatterParams){
        return cell.getValue() ?? 'ไม่มีบัตรประจำตัวประชาชน'
    }},
    {title:"ที่อยู่", field:"full_address", hozAlign:"left", formatter:"textarea", resizable:true, minWidth: 300},
    {title:"ช่วงวัย", field:"age_range", hozAlign:"center", minWidth: 200, width: 250, variableHeight:true, mutator: customAgeRange,
        formatter:function(cell, formatterParams){
            var value = cell.getValue();
            if(value){
                let temp = ""
                for(const [key, val] of Object.entries(value)){
                    let icon = "", text = ""
                    if(key === "baby"){
                        icon = "baby-icon"
                        text = "เด็กแรกเกิด/ปฐมวัย (อายุ 0-5 ปี)"
                    }
                    if(key === "kid"){
                        icon = "kid-icon"
                        text = "วัยเรียน (อายุ 5-14 ปี)"
                    }
                    if(key === "teenager"){
                        icon = "teenager-icon"
                        text = "วัยรุ่น/นักศึกษา (อายุ 15-21 ปี)"
                    }
                    if(key === "adult"){
                        icon = "adult-icon"
                        text = "วัยผู้ใหญ่/วัยแรงงาน (อายุ 18-59 ปี)"
                    }
                    if(key === "elder"){
                        icon = "elder-icon"
                        text = "วัยผู้สูงอายุ (60 ปีขึ้นไป)"
                    }
                    temp+= `<button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-1 mb-1 text-white ${val ? 'bg-theme-1 hover:bg-theme-1':'bg-theme-37 hover:bg-theme-37'}'>\
                                <span class="t-tooltip-text">${text}</span>\
                                <span class="img-icon ${icon}"></span>\
                            </button>`
                }
                let res = `<div class="flex flex-wrap justify-start lg:justify-center">${temp}</div>`
                return res
            }
            return null
        }
    },
    {title:"วันที่ปรับปรุงข้อมูลล่าสุด", field:"UPDATE_DATETIME", hozAlign:"center", minWidth: 200, width: 220, variableHeight:true,
        formatter:function(cell, formatterParams){
            if(cell.getValue()){
                let date = cell.getValue().split`T`[0]
                date = new Date(date)
                return [String(date.getDate()).padStart(2, '0'),
                        String(date.getMonth() + 1).padStart(2, '0'),
                  date.getFullYear() + 543
                ].join('/');
            }
            return null
        }
    },
    {title:"สถานะ", field:"member_surveys.status", hozAlign:"center", resizable:true, minWidth: 130, width: 150, formatter:"textarea", formatter:function(cell, formatterParams){
    return cell.getValue() == "DRAFT" ? "ร่าง" : cell.getValue() == "COMPLETE" ? "สำเร็จ" : null
  }},
])
const handleRowClick = (row) =>{
    if(getPermissionAccessMenu("read") || !onlineComputed.value){
        router.push({
            name: 'view-member',
            params: {
                hhid: row.house_id,
                surveyid: row.house_surveys_id,
                memberid: row._id
            },
        })
    }
}


watch(()=> props.downloadCsv, (val)=>{
    if(val){
        downloadFile.value = props.downloadCsv
        currentFileType.value = "csv"
        downloadFormat.value = val
    }
})

watch(()=> props.downloadExcel, (val)=>{
    if(val){
        downloadFile.value = props.downloadExcel
        currentFileType.value = "xlsx"
        downloadFormat.value = val
    }
})

const exportFile = (evt, questions) => {
    let genderOption = []
    let maritalStatusOption = []
    let regionOption = []
    if(evt.status === 200){
        let columns_header = {
            toExport: ["HH001","IN001","IN003"],
            toCompare: []
        }
        const getExportCodesForQuestion = (q) => {
            if(q.question_code == "prefix_name")
                return ["IN002"]
            if(q.question_code == "name")
                return ["IN004"]
            if(q.question_code == "gender"){
                genderOption = q.choices.map((elm, idx)=>{
                    return {
                        code: idx+1,
                        desc: elm.label
                    }
                })
                return ["IN005", "IN005-1"]
            }
            if(q.question_code == "relation")
                return ["IN006"]
            if(q.question_code == "birthdate")
                return ["IN007"]
            if(q.question_code == "age")
                return ["IN008"]
            if(q.question_code == "marital_status"){
                maritalStatusOption = q.choices.map((elm, idx)=>{
                    return {
                        code: idx+1,
                        desc: elm.label
                    }
                })
                return ["IN009", "IN009-1"]
            }
            if(q.question_code == "religion"){
                regionOption = q.choices.map((elm, idx)=>{
                    return {
                        code: idx+1,
                        desc: elm.label
                    }
                })
                return ["IN010", "IN010-1"]
            }
            if(q.question_code == "mobile")
                return ["IN011"]
            if(q.question_type == "checkbox"){
                if(q.is_checkbox_group){
                    const res = q.choices.map(c => {
                        if(c?.specify_value?.length > 1){
                            let tempCh = []
                            let current_code = q.is_new_survey ? c.option.code : parseInt(c.option.code.replace(/[^\d]/g, ""))
                            let current_text_code = c.option.code.replace(/[\d]/g, "")
                            for(let i = 1 ; i <= c.specify_value.length; i++){
                                if(q.is_new_survey){
                                    tempCh.push(`${c.option.code}-${i}`)
                                }
                                else{
                                    tempCh.push(`${current_text_code}${String(current_code).padStart(3, '0')}`)
                                    current_code++
                                }
                            }
                            return tempCh
                        }
                        return c.option.code
                    }).flat()
                    columns_header.toCompare.push(q.question_code)
                    return res
                }
                else if(q.choices.some(c => c.option.hasOwnProperty("order"))){
                    let haveSpecify = q.choices.find(c => c.specify_value)

                    let temp = []
                    for(let i = 1; i<=q.answer_limit; i++){
                        temp.push(`${q.question_code}-${i}`)
                        if(haveSpecify){
                            for(let j = 1 ; j <= haveSpecify.specify_value.length; j++){
                                temp.push(`${q.question_code}-${i}-${j}`)
                            }
                        }
                    }
                    return temp
                }
                else{
                    if(q.choices.length){
                        let haveSpecify = q.choices.find(c => c.specify_value)
                        let temp = []
                        for(let i = 1; i <= q.choices.length; i++){
                            temp.push(`${q.question_code}-${i}`)
                            if(haveSpecify){
                                for(let j = 1 ; j <= haveSpecify.specify_value.length; j++){
                                    temp.push(`${q.question_code}-${i}-${j}`)
                                }
                            }
                        }
                        return temp
                    }
                }
            }
            if((q.question_type == "radio") && q.choices.some(c => c.specify_value)){
                let specify = q.choices.find(c=>c.specify_value)
                let tempCode = []
                if(specify){
                    for(let i = 1 ; i <= specify.specify_value.length; i++){
                        tempCode.push(`${q.question_code}-${i}`)
                    }
                }
                return [q.question_code,...tempCode]
            }
            if(q.question_type == "multiple-inputs-answer"){
                if(q.choices.length > 1){
                    let tempCh = []
                    let current_code = q.is_new_survey ? q.question_code : parseInt(q.question_code.replace(/[^\d]/g, ""))
                    let current_text_code = q.question_code.replace(/[\d]/g, "")
                    for(let i = 1 ; i <= q.choices.length; i++){
                        if(q.is_new_survey){
                            tempCh.push(`${current_code}-${i}`)
                        }
                        else{
                            tempCh.push(`${current_text_code}${String(current_code).padStart(3, '0')}`)
                            current_code++
                        }
                    }
                    return tempCh
                }
                return [q.question_code]
            }
            return [q.question_code]
        }

        const questionExportCodes = questions.map((q) => ({ q, codes: getExportCodesForQuestion(q) }))
        columns_header.toExport = [...columns_header.toExport, ...questionExportCodes.map(({ codes }) => codes).flat()]
        columns_header.toExport = columns_header.toExport.sort((a, b) =>
            a.localeCompare(b, undefined, { numeric: true })
        )
        columns_header.toExport.unshift("province_name", "amphur_name", "tambol_name", "village_name", "age_year", "age_month")
        columns_header.toExport.push("survey_status", "survey_start_date", "survey_end_date", "survey_start_time", "survey_end_time", "member_id", "house_id")

        const EXCLUDED_QUESTION_DICTIONARY_CODES = ["month", "surname", "survey_date"]
        const MANUAL_QUESTION_DICTIONARY_LABELS = { HH001: "รหัสประจำบ้าน", IN001: "ลำดับสมาชิกในครัวเรือน", IN003: "เลขบัตรประจำตัวประชาชน", IN008: "อายุ" }
        const OTHER_SPECIFY_CODES = ["IN005-1", "IN009-1", "IN010-1"]
        const getDictionaryLabel = (q, code) => {
            if(OTHER_SPECIFY_CODES.includes(code)) return `${q.question_desc} (กรณีเลือกอื่นๆ)`
            if(q.question_type == "checkbox" && q.is_checkbox_group){
                const choice = q.choices.find((c) => code === c.option.code || code.startsWith(`${c.option.code}-`))
                if(choice) return `${q.question_desc} (${choice.option.desc})`
            }
            if(q.question_type == "radio" && q.choices.some((c) => c.specify_value)){
                if(code != q.question_code && code.startsWith(`${q.question_code}-`)) return `${q.question_desc} (กรณีตอบอื่นๆ)`
            }
            return q.question_desc
        }
        const questionDictionaryRows = [
            ...Object.entries(MANUAL_QUESTION_DICTIONARY_LABELS).map(([code, label]) => ({ "รหัสคำถาม": code, "ชื่อคำถาม": label })),
            ...questionExportCodes.flatMap(({ q, codes }) =>
                codes
                    .filter((code) => !EXCLUDED_QUESTION_DICTIONARY_CODES.includes(code) && !MANUAL_QUESTION_DICTIONARY_LABELS[code])
                    .map((code) => ({ "รหัสคำถาม": code, "ชื่อคำถาม": getDictionaryLabel(q, code) }))
            ),
        ].sort((a, b) => a["รหัสคำถาม"].localeCompare(b["รหัสคำถาม"], undefined, { numeric: true }))

        let newArr = evt.data.map((item)=>{
            let newItem = {}
            for(let col of columns_header.toExport){
                if(item[col])
                    newItem[col] = item[col]
                else
                    newItem[col] = null
            }
            //sort column
            if(item.house_number_ID)
                newItem["HH001"] = item.house_number_ID
            // if(item.prefix_name){
            //     newItem["IN002"] = item.prefix_name
            // }
            if(item.NID || item.IDNumber || item.IN003){
                newItem["IN003"] = hashText(item.NID || item.IDNumber || item.IN003)
            }
            // if(item.name && item.surname){
            //     newItem["IN004"] = item.name+' '+item.surname
            // }
            if(item.gender){
                if(downloadFormat.value == "desc"){
                    newItem["IN005"] = genderOption.find(x=> x.desc == item.gender).desc
                }
                else{
                    newItem["IN005"] = genderOption.find(x=> x.desc == item.gender).code
                }
            }
            if(item.gender_other){
                newItem["IN005-1"] = item.gender_other
            }
            // if(item.birthdate){
            //     newItem["IN007"] = item.birthdate
            // }
            // if(item.age_year || item.age_year == 0){
            //     newItem["IN008"] = item.age_year+" ปี "+ item.age_month+ " เดือน"
            // }
            if(item.marital_status){
                if(downloadFormat.value == "desc"){
                    newItem["IN009"] = maritalStatusOption.find(x=> x.desc == item.marital_status).desc
                }
                else{
                    newItem["IN009"] = maritalStatusOption.find(x=> x.desc == item.marital_status).code
                }
            }
            if(item.marital_status_other){
                newItem["IN009-1"] = item.marital_status_other
            }
            if(item.religion){
                if(downloadFormat.value == "desc"){
                    newItem["IN010"] = regionOption.find(x=> x.desc == item.religion).desc
                }
                else{
                    newItem["IN010"] = regionOption.find(x=> x.desc == item.religion).code
                }
            }
            if(item.religion_other){
                newItem["IN010-1"] = item.religion_other
            }
            // if(item.mobile){
            //     newItem["IN011"] = item.mobile
            // }
            if(item.member_surveys){
                const keys = Object.keys(item.member_surveys)
                if(item.member_surveys.age_year || item.member_surveys.age_year == 0)
                    newItem["IN008"] = item.member_surveys.age_year+" ปี "+ item.member_surveys.age_month+ " เดือน"
                if(item.member_surveys.relation){
                    if(downloadFormat.value == "desc"){
                        newItem["IN006"] = item.member_surveys.relation.desc
                    }
                    else{
                        newItem["IN006"] = item.member_surveys.relation.code
                    }
                }
                if(item.member_surveys.status)
                    newItem["survey_status"] = item.member_surveys.status
                if(item.member_surveys.survey_start_date)
                    newItem["survey_start_date"] = item.member_surveys.survey_start_date
                if(item.member_surveys.survey_end_date)
                    newItem["survey_end_date"] = item.member_surveys.survey_end_date

                if(item.member_surveys.IN131 >= 0 && (item.member_surveys.IN129 == null ||item.member_surveys.IN130 == null ))
                    item.member_surveys.IN131 = null
                if(item.member_surveys.IN134 >= 0 && (item.member_surveys.IN132 == null ||item.member_surveys.IN133 == null ))
                    item.member_surveys.IN134 = null
                keys.forEach((elm)=>{
                    if((item.member_surveys[elm] || item.member_surveys[elm] == 0) && Object.values(columns_header).flat().some(col => col.includes(elm))){
                        if(typeof item.member_surveys[elm] === "object"){
                            let tempObj = questions.find(({question_code}) => elm === question_code)
                            if(Array.isArray(item.member_surveys[elm]) && tempObj){
                                if(questions.some(q=>q.question_code == elm && q.is_checkbox_group)){
                                    let temp = []
                                    item.member_surveys[elm].forEach((it)=>{
                                        const choice = tempObj.choices.find(x => x.option.code === it.code)
                                        if(choice?.is_multiple_answer){
                                            if(choice?.specify_value && it?.answers){
                                                let current_question_code = tempObj.is_new_survey ? choice.option.code : parseInt(choice.option.code.replace(/[^\d]/g, ""))
                                                const current_question_text_code = choice.option.code.replace(/[\d]/g, "")
                                                let i = 0
                                                for(let ch of choice.specify_value){
                                                    let codeNum = null
                                                    i++
                                                    if(choice.specify_value.length == 1){
                                                        codeNum = choice.option.code
                                                    }
                                                    else{
                                                        if(tempObj.is_new_survey){
                                                            codeNum = `${choice.option.code}-${i}`
                                                        }
                                                        else{
                                                            codeNum = `${current_question_text_code}${String(current_question_code).padStart(3, '0')}`
                                                            current_question_code++
                                                        }
                                                    }
                                                    let valueArr = []
                                                    for(let val of it.answers){
                                                        if(val[ch.key] || val[ch.key] == 0){
                                                            valueArr.push(val[ch.key])
                                                        }
                                                    }
                                                    temp.push({code: codeNum, value: valueArr.join(", ")})
                                                }
                                            }
                                        }
                                        else{
                                            if(choice?.specify_value){
                                                let current_question_code = tempObj.is_new_survey ? choice.option.code : parseInt(choice.option.code.replace(/[^\d]/g, ""))
                                                const current_question_text_code = choice.option.code.replace(/[\d]/g, "")
                                                let i = 0
                                                for(let ch of choice.specify_value){
                                                    let codeNum = null
                                                    i++
                                                    if(choice.specify_value.length == 1){
                                                        codeNum = choice.option.code
                                                    }
                                                    else{
                                                        if(tempObj.is_new_survey){
                                                            codeNum = `${choice.option.code}-${i}`
                                                        }
                                                        else{
                                                            codeNum = `${current_question_text_code}${String(current_question_code).padStart(3, '0')}`
                                                            current_question_code++
                                                        }
                                                    }
                                                    if(it[ch.key] || it[ch.key] == 0){
                                                        temp.push({code: codeNum, value: it[ch.key]})
                                                    }
                                                }
                                            }
                                        }

                                    })
                                    const newData = temp.reduce((a,v)=> ({...a, [v.code]: v.value}),{})
                                    return newItem = {...newItem, ...newData}
                                }
                                else{
                                    const res = item.member_surveys[elm].reduce((temp,v, idx)=> {
                                        const choice = tempObj.choices.find(x => x.option.code === v.code)
                                        let tempDesc = ""
                                        let tempAnswerObj = {}
                                        if(downloadFormat.value == "desc"){
                                            tempDesc = choice ? choice.option.desc : v.desc
                                        }
                                        else{
                                            tempDesc = choice ? choice.option.code.split('-')[1] : v.code.split('-')[1]
                                        }
                                        tempAnswerObj = {...tempAnswerObj, [`${elm}-${idx+1}`]: tempDesc}
                                        if(choice?.is_multiple_answer){
                                            if(choice?.specify_value && v?.answers){
                                                let i = 0
                                                for(let ch of choice.specify_value){
                                                    i++
                                                    let valueArr = []
                                                    for(let val of v.answers){
                                                        if(val[ch.key] || val[ch.key] == 0){
                                                            valueArr.push(val[ch.key])
                                                        }
                                                    }
                                                    tempAnswerObj = {...tempAnswerObj, [`${elm}-${idx+1}-${i}`]: valueArr.join(", ")}
                                                }
                                            }
                                        }
                                        else{
                                            if(choice?.specify_value){
                                                let i = 0
                                                for(let ch of choice.specify_value){
                                                    i++
                                                    if(v[ch.key] || v[ch.key] == 0){
                                                        tempAnswerObj = {...tempAnswerObj, [`${elm}-${idx+1}-${i}`]: v[ch.key]}
                                                    }
                                                }
                                            }
                                        }
                                        return {...temp, ...tempAnswerObj}
                                    },{})
                                    return newItem = {...newItem,...res}
                                }
                            }
                            else{
                                if(item.member_surveys[elm]?.code && tempObj && tempObj?.question_type != "relation"){
                                    const choice = tempObj.choices.find(x => x.option.code === item.member_surveys[elm].code)
                                    let tempDesc = ""
                                    let tempAnswerObj = {}
                                    if(downloadFormat.value == "desc"){
                                        tempDesc = choice ? choice.option.desc : item.member_surveys[elm].desc
                                    }
                                    else{
                                        tempDesc = choice ? choice.option.code.split('-')?.[1] ? choice.option.code.split('-')[1] : choice.option.code.split('-')[0]  : item.member_surveys[elm].code.split('-')?.[1] ? item.member_surveys[elm].code.split('-')[1] : item.member_surveys[elm].code.split('-')[0]
                                    }
                                    tempAnswerObj = {...tempAnswerObj, [elm]: tempDesc}
                                    if(choice?.is_multiple_answer){
                                        if(choice?.specify_value && item.member_surveys[elm]?.answers){
                                            let i = 0
                                            for(let ch of choice.specify_value){
                                                i++
                                                let valueArr = []
                                                for(let val of item.member_surveys[elm].answers){
                                                    if(val[ch.key] || val[ch.key] == 0){
                                                        valueArr.push(val[ch.key])
                                                    }
                                                }
                                                tempAnswerObj = {...tempAnswerObj, [`${elm}-${i}`]: valueArr.join(", ")}
                                            }
                                        }
                                    }
                                    else{
                                        if(choice?.specify_value){
                                            let i = 0
                                            for(let ch of choice.specify_value){
                                                i++
                                                if(item.member_surveys[elm][ch.key] || item.member_surveys[elm][ch.key] == 0){
                                                    tempAnswerObj = {...tempAnswerObj, [`${elm}-${i}`]: item.member_surveys[elm][ch.key]}
                                                }
                                            }
                                        }
                                    }
                                    return newItem = {...newItem, ...tempAnswerObj}
                                }
                                else if(tempObj?.question_type == "multiple-inputs-answer"){//object answer has no desc only this type
                                    const choice = tempObj.choices
                                    let current_question_code = tempObj.is_new_survey ? tempObj.question_code : parseInt(tempObj.question_code.replace(/[^\d]/g, ""))
                                    const current_question_text_code = tempObj.question_code.replace(/[\d]/g, "")
                                    let i = 0
                                    let tempInp = {}
                                    for(let ch of choice){
                                        i++
                                        let codeNum = null
                                        if(choice.length == 1){
                                            codeNum = current_question_code
                                        }
                                        else{
                                            if(tempObj.is_new_survey){
                                                codeNum = `${current_question_code}-${i}`
                                            }
                                            else{
                                                codeNum = `${current_question_text_code}${String(current_question_code).padStart(3, '0')}`
                                                current_question_code++
                                            }
                                        }
                                        if(item.member_surveys[elm][ch.key] || item.member_surveys[elm][ch.key] == 0){
                                            tempInp = {...tempInp, [codeNum]: item.member_surveys[elm][ch.key]}
                                        }
                                    }
                                    return newItem = {...newItem, ...tempInp}
                                }
                            }
                        }
                        return newItem[elm] = item.member_surveys[elm]
                    }
                })
            }
            return newItem
        })
        newArr = newArr.map(({status, create_by, update_by, age_range, survey_date, NEET, CWD, CREATE_DATETIME, UPDATE_DATETIME, month, relation, surname, _id, ...rest}) => ({...rest}));
        const ws = utils.json_to_sheet(newArr)
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Sheet1");
        if(currentFileType.value == "xlsx"){
            const questionDictionaryWs = utils.json_to_sheet(questionDictionaryRows)
            utils.book_append_sheet(wb, questionDictionaryWs, "รหัสคำถาม")
        }
        let date = new Date()
        let current_date = [date.getFullYear(),String(date.getMonth() + 1).padStart(2, '0'),String(date.getDate()).padStart(2, '0'),String(date.getHours()).padStart(2, '0'),String(date.getMinutes()).padStart(2, '0'),String(date.getSeconds()).padStart(2, '0')].join('')
        let file_name = `${props.filter?.village_ID ? props.filter.village_ID : props.filter?.tambol_ID ? props.filter.tambol_ID : props.filter?.amphur_ID ? props.filter.amphur_ID : props.filter?.province_ID ? props.filter.province_ID : "" }_สมาชิก_${downloadFormat.value == "code" ? 'รหัส' : 'คำอธิบาย'}_${current_date}`
        //for csv
        if(currentFileType.value == "csv"){
            writeFile(wb, `${file_name}.csv`);
        }
        //for excel
        if(currentFileType.value == "xlsx"){
            writeFile(wb, `${file_name}.xlsx`);
        }
    }else{
        Swal.fire({
        icon: "warning",
        text: "ระบบผิดพลาด",
        })
    }
    downloadFile.value = false
    emits("downloadCsvComplete")
    emits("downloadExcelComplete")
}

</script>

<style lang="scss">
.member-datatable {

}
</style>